
export const getLineSummary = (lines) => {

    let totalSaved = 0;
    let maxSaving = 0;
    const appliedSavings = {}
    const furtherSavings = {};

    for(const line of lines) {
        const product = line.M_Product_ID;

        const breakQtySaving = (product.applied?.find(a => a.type === 'BR')?.discount ?? 0);

        const discount = (product.discount + breakQtySaving) * line.QtyOrdered;
        const bestDiscount = product.best_discount * line.QtyOrdered;

        totalSaved += discount;
        maxSaving += bestDiscount;

        for(const applied of (product.applied ?? [])) {
            const type = applied.type;
            appliedSavings[type] = (appliedSavings[type] ?? 0) + discount
        }

        for(const unmet of (product.unmet ?? [])) {
            const type = unmet.type;
            if(!furtherSavings[type])
                furtherSavings[type] = {};

            const k = {
                'OS': unmet.min_amt,
                'BR': unmet.break_val
            }[type] || 0;

            if(!furtherSavings[type][k])
                furtherSavings[type][k] = { ...unmet, discount:0 }

            const lineSaving = unmet.discount * line.QtyOrdered;
            furtherSavings[type][k].discount = furtherSavings[type][k].discount + lineSaving;
        }
    }

    for(const key of Object.keys(furtherSavings)) {
        const lines = Object.values(furtherSavings[key]);
        lines.sort((a,b) => b.seqNo - a.seqNo)
        furtherSavings[key] = lines;
    }


    return {
        totalSaved,
        maxSaving,
        appliedSavings,
        furtherSavings
    }
}